import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { GENERAL_CONSTANTS, STATE } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ACTIONS_TYPES,
  COLLECTIONS_CAN_CHANGE_MEDICAL_ORDER,
  FILTERS_NAMES_CONST,
  GENERAL_RULES_CONSTANTS,
  ID_LIST,
  MEDICAL_ORDER_LABELS_FORM,
  NOTIFICATION_EXE_RULES_FIELDS,
  ORDER,
  RULES_ACCESS,
  RULE_NEW
} from "../../constants/GeneralRulesConstants";
import { ActionGeneralRules } from "../../models/actions.model";
import Order from "../Order/Order.vue";
import NotificationModal from "@/modules/Notification/components/NotificationModal/NotificationModal.vue";
import { InfoGroupService } from "@/modules/InfoGroup/services/InfoGroupService";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import {
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { Http } from "@status/codes";
import { USER_TEMP_CONSTANTS } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import Task from "../Tasks/Task.vue";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { MedicalOrderModel } from "@/modules/MedicalOrder/models/MedicalOrderModel";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { DataTransferActions } from "../../models/DataTransferActions.model";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { ListService } from "@/modules/List/services/ListService";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { OrderService } from "@/modules/Orders/services/OrderService";
import { FieldOrder } from "@/modules/Orders/models/FieldOrder";
import { FORMS_CONSTANTS } from "@/modules/Forms/constants/FormsConstants";
import { CupsPriceLevelHeader } from "@/modules/CupsPriceLevels/models/CupsPriceLevelHeader";
import { Response } from "@/shared/models/Response";
import { TaskModel } from "../../models/TaskModel.model";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { GeneralRulesService } from "../../services/GeneralRulesService";
import Vuetify from "vuetify";
import { ServiceTemplateHeader } from "@/modules/ServiceTemplate/models/ServiceTemplateHeader";
import {
  DEFAULT_ACTION,
  RELATED_SERVICE,
  TYPE_STRING
} from "./constants/action.constants";
import lodash from "lodash";
import StopConditions from "../StopConditions/StopConditions.vue";
import GenerateDocument from "../GenerateDocument/components/GenerateDocument.vue";
import FormActionModal from "../FormActionModal/FormActionModal.vue";
import { StopCondition } from "../../models/StopCondition.model";
import { Collection } from "../../models/Collection.model";
import { GenaralRuleField } from "../../models/GenaralRuleField.model";
import { GeneralRule } from "../../models/GeneralRule";
import { ActionPlanStatus } from "@/modules/ActionPlan/models/ActionPlanStatus.model";
import { FormConfiguration } from "../../models/FormConfiguration.model";
import { AxiosError } from "axios";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { ORDER_ACCESS } from "@/modules/Orders/constants/OrderConstants";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import AssignServiceActionModal from "../AssignService/AssignServiceActionModal.vue";
import { Service } from "@/modules/Services/models/Service";
import { ConditionGeneralRules } from "../../models/condition.model";
import { KeyValue } from "@/shared/models/KeyValue";
import ChangeStateService from "../ChangeStateService/ChangeStateService.vue";
import { ChangeStateServiceModel } from "../../models/ChangeStateService.model";
import ChangeMedicalOrder from "../ChangeMedicalOrder/ChangeMedicalOrder.vue";
import { ChangeMedicalOrderModel } from "../../models/ChangeMedicalOrderModel";
import store from "@/store";
import { CampusService } from "@/modules/Campus/services/CampusService";
import { MEDICAL_ORDER_ACCESS } from "@/modules/MedicalOrder/constants/MedicalOrderConstants";

Vue.use(Vuetify);
@Component({
  name: "Actions",
  components: {
    NotificationModal,
    Order,
    Task,
    ModalTemplate,
    StopConditions,
    GenerateDocument,
    FormActionModal,
    AssignServiceActionModal,
    ChangeStateService,
    ChangeMedicalOrder
  }
})
export default class Actions extends Vue {
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() listService!: ListService;
  @Inject() orderService!: OrderService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() generalRulesService!: GeneralRulesService;
  @Inject() campusService!: CampusService;

  @Prop() fetchActions!: boolean;
  @Prop() collection!: Collection;
  @Prop() isEditing!: boolean;
  @Prop() actionsEditing!: ActionGeneralRules[];
  @Prop() ruleId!: string;
  @Prop() newRule!: boolean;
  @Prop() conditions!: ConditionGeneralRules[];
  @Prop() dataTransferActions!: DataTransferActions;
  @Prop() sessionOrderService?: boolean;

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  ACTIONS_DROPDOWN = GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN;
  actions: ActionGeneralRules[] = [];
  actionsTypes: { actionType: string; actions: ActionGeneralRules[] }[] = [
    { actionType: GENERAL_RULES_CONSTANTS.MEDICAL_ORDER, actions: [] },
    { actionType: GENERAL_RULES_CONSTANTS.TASK, actions: [] },
    { actionType: GENERAL_RULES_CONSTANTS.NOTIFICATION, actions: [] },
    { actionType: GENERAL_RULES_CONSTANTS.DOCUMENTS, actions: [] },
    { actionType: GENERAL_RULES_CONSTANTS.FORM, actions: [] },
    { actionType: GENERAL_RULES_CONSTANTS.SERVICE, actions: [] },
    { actionType: GENERAL_RULES_CONSTANTS.RPA, actions: [] },
    {
      actionType: GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION,
      actions: []
    },
    {
      actionType: GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER,
      actions: []
    }
  ];
  typeActionselected = GENERAL_RULES_CONSTANTS.ACTION_TYPE;
  cardClass = STYLE_CLASSES.CARD;
  ACTIONS_TYPES = ACTIONS_TYPES;
  addActionIcon = GENERAL_CONSTANTS.ICONS.ADD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  showModalMedicalOrder = false;
  showModalNotifications = false;
  showModalTasks = false;
  showModalForms = false;
  userInfoParams: NotificationParams[] = [];
  actionContainerToDelete = "";
  dialogDelete = false;
  modalText = "";
  ORDER = ORDER;
  MEDICAL_ORDER = GENERAL_RULES_CONSTANTS.MEDICAL_ORDER;
  CHANGE_MEDICAL_ORDER = GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER;
  RPA = GENERAL_RULES_CONSTANTS.RPA;
  NOTIFICATION = GENERAL_RULES_CONSTANTS.NOTIFICATION;
  TASK = GENERAL_RULES_CONSTANTS.TASK;
  FORM = GENERAL_RULES_CONSTANTS.FORM;
  SEARCH_SERVICE = GENERAL_RULES_CONSTANTS.SEARCH_SERVICE;
  TYPE_STRING = TYPE_STRING;
  modalTitle = "";
  MEDICAL_ORDER_LABELS_FORM = MEDICAL_ORDER_LABELS_FORM;
  cupsStore: CupsPriceLevelHeader[] = [];
  serviceTemplates: ServiceTemplateHeader[] = [];
  indexInContainer = -1;
  actionType = "";
  priceLvlsList: { keys: string[]; values: string[] } = {
    keys: [],
    values: []
  };
  edit = false;
  actionToEdit: ActionGeneralRules = lodash.cloneDeep(DEFAULT_ACTION);
  editNotification = false;
  editTask = false;
  editForm = false;
  editService = false;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  formTemplatesList: List[] = [];
  diagnosisCodes: string[] = [];
  campusList: { key: string; name: string }[] = [];
  fieldsOrder: FieldOrder[] = [];
  userList: List[] = [];
  showStopConditionsModal = false;
  showGenerateDocument = false;
  formsCollection = FILTERS_NAMES_CONST.FORM.KEY;
  serviceCollection = FILTERS_NAMES_CONST.SERVICE.KEY;
  stopConditions: StopCondition[] = [];
  actionTypeIndex = -1;
  fieldsForStopConditions: GenaralRuleField[] = [];
  STOP_CONDITION_TOOLTIP =
    GENERAL_RULES_CONSTANTS.TOOLTIP.STOP_CONDITION_TOOLTIP;
  STOP_CONDITION_ALERT = GENERAL_RULES_CONSTANTS.STOP_CONDITION_ALERT;
  EDIT_ACTION = GENERAL_RULES_CONSTANTS.TOOLTIP.EDIT;
  DELETE_ACTION = GENERAL_RULES_CONSTANTS.TOOLTIP.DELETE;
  EXECUTE_RULES_NOTIFICACION =
    GENERAL_RULES_CONSTANTS.TOOLTIP.EXECUTE_RULES_NOTIFICACION;
  generalRule: GeneralRule = RULE_NEW;
  filterActions: string[] = GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN;
  keyWord = "";
  showAssignServiceModal = false;
  lastRefFormTemplate: string | undefined = undefined;
  executeRulesNotidicationModal = false;
  executeConditionsNotificationList: GenaralRuleField[] = [];
  showChangeServiceStateModal = false;
  showChangeMedicalOrderModal = false;
  editComparationStr = "";
  invalidEdit = false;
  orderStates: { id: string; name: string }[] = [];
  formTemplateSelected: string[] = [];

  mounted() {
    if (this.isEditing) {
      this.preloadActions();
    }
    this.loadInfoGroupFieldsByName();
    this.getTemplate();
    this.getFormTemplates();
    this.listenConditions();
  }

  @Watch("newRule")
  @Watch("ruleId")
  async listenRuleId() {
    if (this.ruleId === "") {
      this.actions = [];
      this.actionsTypes = [
        { actionType: GENERAL_RULES_CONSTANTS.MEDICAL_ORDER, actions: [] },
        { actionType: GENERAL_RULES_CONSTANTS.TASK, actions: [] },
        { actionType: GENERAL_RULES_CONSTANTS.NOTIFICATION, actions: [] },
        { actionType: GENERAL_RULES_CONSTANTS.DOCUMENTS, actions: [] },
        { actionType: GENERAL_RULES_CONSTANTS.FORM, actions: [] },
        { actionType: GENERAL_RULES_CONSTANTS.SERVICE, actions: [] },
        { actionType: GENERAL_RULES_CONSTANTS.RPA, actions: [] },
        {
          actionType: GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION,
          actions: []
        },
        {
          actionType: GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER,
          actions: []
        }
      ];
      return;
    }
    await this.preloadActions();
    await this.loadInfoGroupFieldsByName();
    await this.getTemplate();
  }

  @Watch("fetchActions")
  sendActions() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SEND_ACTIONS_TO_SAVE, {
      actions: this.actions,
      cupsStore: this.cupsStore,
      priceLvlsList: this.priceLvlsList
    });
  }
  @Watch("actions", { deep: true })
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify(this.actions) === this.editComparationStr;
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.CHECK_ACTION_EDIT, {
        equal: this.invalidEdit
      });
    }
  }
  @Watch("actions")
  validateActions() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.DISABLED_SAVE_BUTTON);
  }

  deleteActionsTypeContainer(actionContainer: string) {
    this.actionContainerToDelete = actionContainer;
    this.modalText =
      GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_ALL_ACTIONS_TYPE.MESSAGE +
      actionContainer +
      "?";
    this.modalTitle =
      GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_ALL_ACTIONS_TYPE.TITLE;
    this.dialogDelete = true;
    //this.isEditing = false;
  }

  getMedicalOrderService(model: MedicalOrderModel | undefined): string {
    let response = "";
    if (model?.service) {
      response =
        this.serviceTemplates.find(element => element.id === model.service)
          ?.internalName || "";
    }
    return response;
  }

  actionSelect() {
    if (
      !this.filterActions.includes(GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[5])
    ) {
      Snackbar.popInfo(
        GENERAL_RULES_CONSTANTS.MESSAGES.ACTION_BLOCKED_SAVE_ASSIGN_SERVICE
      );
    }
  }

  addAction(action: string) {
    this.keyWord = "";
    this.actionType = action;
    this.edit = false;
    switch (action) {
      case GENERAL_RULES_CONSTANTS.MEDICAL_ORDER:
        this.openOrder();
        break;
      case GENERAL_RULES_CONSTANTS.TASK:
        this.showModalTasks = true;
        break;
      case GENERAL_RULES_CONSTANTS.NOTIFICATION:
        this.openNotifications();
        break;
      case GENERAL_RULES_CONSTANTS.DOCUMENTS:
        this.openGenerateDocument();
        break;
      case GENERAL_RULES_CONSTANTS.FORM:
        this.showModalForms = true;
        break;
      case GENERAL_RULES_CONSTANTS.SERVICE:
        this.openAssignService();
        break;
      case GENERAL_RULES_CONSTANTS.RPA:
        this.addRpaAction();
        break;
      case GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION:
        this.changeServiceState();
        break;
      case GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER:
        this.changeMedicalOrder();
        break;
    }
  }
  changeServiceState() {
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.showChangeServiceStateModal = true;
  }

  changeMedicalOrder() {
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.showChangeMedicalOrderModal = true;
  }

  isDisabled(action: string) {
    if (
      this.dataTransferActions.collectionName == GENERAL_RULES_CONSTANTS.LEAD &&
      action != GENERAL_RULES_CONSTANTS.NOTIFICATION
    ) {
      return true;
    }

    let isDisabled = false;
    switch (action) {
      case GENERAL_RULES_CONSTANTS.RPA:
        if (
          this.dataTransferActions.collectionName !==
          FILTERS_NAMES_CONST.ORDER.KEY
        ) {
          isDisabled = true;
        }
        break;
      case GENERAL_RULES_CONSTANTS.TASK:
        if (
          [
            FILTERS_NAMES_CONST.FORM.KEY,
            FILTERS_NAMES_CONST.SESSION.KEY
          ].includes(this.dataTransferActions.collectionName)
        ) {
          isDisabled = false;
        }
        break;
      case ACTIONS_TYPES[8].key:
        if (
          !COLLECTIONS_CAN_CHANGE_MEDICAL_ORDER.includes(
            this.dataTransferActions.collectionName
          )
        ) {
          isDisabled = true;
        }
        break;

      default:
        break;
    }
    return isDisabled;
  }

  disabledMessage(action: string) {
    switch (action) {
      case ACTIONS_TYPES[6].key:
        return GENERAL_RULES_CONSTANTS.RPA_DISABLED;
      case ACTIONS_TYPES[8].key:
        return GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER_DISABLED;
      default:
        return GENERAL_RULES_CONSTANTS.ACTION_NOT_AVAILABLE;
    }
  }

  addRpaAction() {
    if (this.actionsTypes[6].actions.length == 0) {
      const actionPlan: ActionPlanStatus = {
        name: GENERAL_RULES_CONSTANTS.RPA_DESCRIPTION,
        state: false,
        category: ""
      };
      const action: ActionGeneralRules = {
        type: GENERAL_RULES_CONSTANTS.RPA,
        actionPlan: actionPlan,
        daysToApply: 0
      };

      this.actionsTypes[6].actions.push(action);
      this.actions.push(action);
    }
  }

  openAssignService() {
    this.showAssignServiceModal = true;
  }

  openGenerateDocument() {
    this.showGenerateDocument = true;
  }

  onCloseGenerateDocument() {
    this.showGenerateDocument = false;
  }

  async openOrder() {
    if (this.actionsTypes[0].actions.length > 0) {
      Snackbar.popError(
        GENERAL_RULES_CONSTANTS.MESSAGES.JUST_ONE_ORDER_TYPE_ACTION
      );
      return;
    }
    if (this.orderStates.length === 0) await this.getOrderStates();
    this.loadServiceSemplate();
    this.getDiagnosticsCodes();
    this.getCampus();
    this.showModalMedicalOrder = true;
  }

  async openNotifications() {
    if (this.userInfoParams.length === 0) {
      await this.loadInfoGroupFieldsByName();
      this.showModalNotifications = true;
      return;
    }
    this.showModalNotifications = true;
  }

  handleModalAccept() {
    try {
      if (
        this.modalTitle ===
        GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_ALL_ACTIONS_TYPE.TITLE
      ) {
        const findIndexInContainer = this.actionsTypes.findIndex(
          item => item.actionType === this.actionContainerToDelete
        );
        this.actionsTypes[findIndexInContainer].actions = [];
        this.actions = this.actions.filter(
          item => item.type !== this.actionContainerToDelete
        );
        this.dialogDelete = false;
        return;
      }
      this.deleteAction(this.actionToEdit, this.actionToEdit.type);
      this.dialogDelete = false;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  handleModalCancel() {
    this.modalText = "";
    this.modalTitle = "";
    this.dialogDelete = false;
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.actionType = "";
  }

  async loadInfoGroupFieldsByName() {
    try {
      const responseData = await this.infoGroupService.getInfoGroupFieldByName(
        INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfoParams = responseData.data;
      } else {
        Snackbar.popInfo(USER_TEMP_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadServiceSemplate() {
    if (this.serviceTemplates.length > 0) {
      return;
    }
    try {
      const response = await this.serviceTemplateService.getAllActiveServiceTemplate(
        this.isEditing ? undefined : STATE.ACTIVE
      );

      if (response.code === Http.Found && response.data) {
        this.serviceTemplates = response.data;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  acceptNotification(notification: NotificationConfig) {
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.NOTIFICATION,
      actionNotification: notification,
      daysToApply: notification.startDate ? notification.startDate : 0,
      stopConditions:
        (notification.notification.frequency
          ? notification.notification.frequency
          : 0) > 0 && this.actionToEdit.stopConditions
          ? [...this.actionToEdit.stopConditions]
          : []
    };

    if (this.editNotification) {
      Vue.set(this.actionsTypes[2].actions, this.indexInContainer, action);
      this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
      this.indexInContainer = -1;
      this.actionType = "";
      this.editNotification = false;
      this.assingActions();
    } else {
      this.actionsTypes[2].actions.push(action);
      this.actions.push(action);
    }

    this.showModalNotifications = false;
  }

  isDocumentActionAlreadySet(actionPlan: ActionPlanStatus) {
    const docs = this.actionsTypes[3].actions.filter(action => {
      if (
        action.actionPlan?.category === actionPlan.category &&
        action.actionPlan?.name === actionPlan.name
      ) {
        return action;
      }
    });
    return docs;
  }

  acceptGenerateDocument(actionPlan: ActionPlanStatus) {
    const docsValidation = this.isDocumentActionAlreadySet(actionPlan);

    if (docsValidation.length > 0) {
      return Snackbar.popWarning(
        GENERAL_RULES_CONSTANTS.MESSAGES.DOCUMENT_ALREADY_SET
      );
    }

    const action = {
      type: GENERAL_RULES_CONSTANTS.DOCUMENTS,
      actionPlan,
      daysToApply: 0
    };

    if (this.edit) {
      Vue.set(this.actionsTypes[3].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.edit = false;
      this.assingActions();
    } else {
      this.actionsTypes[3].actions.push(action);
      this.actions.push(action);
    }
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.onCloseGenerateDocument();
  }

  cancelNotification() {
    this.editNotification = false;
    this.showModalNotifications = false;
  }

  editAction(indexAction: number, type: string) {
    if (type === GENERAL_RULES_CONSTANTS.MEDICAL_ORDER) {
      this.edit = true;
      this.actionToEdit = lodash.cloneDeep(
        this.actionsTypes[0].actions[indexAction]
      );
      this.indexInContainer = indexAction;
      this.actionType = type;
      this.showModalMedicalOrder = true;
    }
    if (type === GENERAL_RULES_CONSTANTS.TASK) {
      this.actionToEdit = lodash.cloneDeep(
        this.actionsTypes[1].actions[indexAction]
      );
      this.indexInContainer = indexAction;
      this.actionType = type;
      this.editTask = true;
      this.showModalTasks = true;
    }
    if (type === GENERAL_RULES_CONSTANTS.NOTIFICATION) {
      this.actionToEdit = lodash.cloneDeep(
        this.actionsTypes[2].actions[indexAction]
      );
      this.indexInContainer = indexAction;
      this.actionType = type;
      this.showModalNotifications = true;
      this.editNotification = true;
    }
    if (type === GENERAL_RULES_CONSTANTS.DOCUMENTS) {
      this.actionToEdit = lodash.cloneDeep(
        this.actionsTypes[3].actions[indexAction]
      );
      this.indexInContainer = indexAction;
      this.actionType = type;
      this.openGenerateDocument();
      this.edit = true;
    }
    if (type === GENERAL_RULES_CONSTANTS.FORM) {
      this.actionToEdit = lodash.cloneDeep(
        this.actionsTypes[4].actions[indexAction]
      );
      this.indexInContainer = indexAction;
      this.actionType = type;

      this.showModalForms = true;
      this.editForm = true;
    }
    if (type === GENERAL_RULES_CONSTANTS.SERVICE) {
      this.editServiceAction(indexAction, type);
    }
    if (type === GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION) {
      this.editServiceStateAction(indexAction, type);
    }
    if (type === GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER) {
      this.editChangeMedicalOrderAction(indexAction, type);
    }
  }
  editServiceStateAction(indexAction: number, type: string) {
    this.actionToEdit = lodash.cloneDeep(
      this.actionsTypes[7].actions[indexAction]
    );
    this.edit = true;
    this.indexInContainer = indexAction;
    this.actionType = type;
    this.showChangeServiceStateModal = true;
  }
  editChangeMedicalOrderAction(indexAction: number, type: string) {
    this.actionToEdit = lodash.cloneDeep(
      this.actionsTypes[8].actions[indexAction]
    );
    this.edit = true;
    this.indexInContainer = indexAction;
    this.actionType = type;
    this.showChangeMedicalOrderModal = true;
  }
  editServiceAction(indexAction: number, type: string) {
    this.actionToEdit = lodash.cloneDeep(
      this.actionsTypes[5].actions[indexAction]
    );
    this.indexInContainer = indexAction;
    this.actionType = type;

    this.showAssignServiceModal = true;
    this.editService = true;
  }

  getOrderActionToSave(
    orderAction: MedicalOrderModel,
    daysToApply: number,
    cupsStoreParam: CupsPriceLevelHeader[],
    priceLvlsListParam: { keys: string[]; values: string[] }
  ) {
    orderAction.priceLevelKey = "";
    this.cupsStore = cupsStoreParam;
    this.priceLvlsList = priceLvlsListParam;
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.MEDICAL_ORDER,
      medicalOrder: orderAction,
      daysToApply: daysToApply,
      stopConditions:
        daysToApply > 0 && this.actionToEdit.stopConditions
          ? [...this.actionToEdit.stopConditions]
          : []
    };

    if (this.edit) {
      Vue.set(this.actionsTypes[0].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.edit = false;
      this.assingActions();
    } else {
      this.actionsTypes[0].actions.push(action);
      this.actions.push(action);
    }
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.showModalMedicalOrder = false;
  }

  getTaskAction(taskAction: TaskModel, daysToApply: number) {
    const action = {
      type: GENERAL_RULES_CONSTANTS.TASK,
      task: taskAction,
      daysToApply: daysToApply,
      stopConditions:
        daysToApply > 0 && this.actionToEdit.stopConditions
          ? [...this.actionToEdit.stopConditions]
          : []
    };
    if (this.editTask) {
      Vue.set(this.actionsTypes[1].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.edit = false;
      this.assingActions();
    } else {
      this.actionsTypes[1].actions.push(action);
      this.actions.push(action);
    }
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.editTask = false;
    this.showModalTasks = false;
  }

  closeModal() {
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.showModalMedicalOrder = false;
    this.showModalTasks = false;
    this.edit = false;
    this.editTask = false;
  }

  deleteOneAction(value: ActionGeneralRules) {
    this.actionToEdit = value;
    this.actionType = value.type;
    this.modalTitle = GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_ACTION.TITLE;
    this.modalText = GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_ACTION.MESSAGE;
    this.dialogDelete = true;
  }

  deleteAction(value: ActionGeneralRules, type: string) {
    const findIndexInActionsTypes = this.actionsTypes.indexOf(
      this.actionsTypes.find(item => item.actionType === type)!
    );

    this.actionsTypes[findIndexInActionsTypes].actions = [
      ...this.actionsTypes[findIndexInActionsTypes].actions.filter(
        item => item !== value
      )
    ];

    this.assingActions();
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.actionType = "";
  }

  async handleFormTemplates(name: string) {
    const responseData = await this.formTemplateService.getFormTemplateWithFilters(
      {
        name,
        state: GENERAL_RULES_CONSTANTS.ACTIVO
      }
    );
    if (responseData.code === Http.Found && responseData.data) {
      responseData.data.data.forEach(({ _key, name }) => {
        this.formTemplatesList.push({ key: _key, name: name });
      });
      this.formTemplatesList = this.formTemplatesList.sort(
        (template1, template2) => template1.name.localeCompare(template2.name)
      );
    }
  }

  async getFormTemplates(templateName?: string) {
    try {
      if (templateName) {
        await this.handleFormTemplates(templateName);
        return;
      }
      const queryFormTemplates = {
        paginatedResult: true,
        state: GENERAL_RULES_CONSTANTS.ACTIVO,
        docref: this.lastRefFormTemplate
      };
      const response = await this.formTemplateService.getFormTemplateWithFilters(
        queryFormTemplates
      );
      if (response.code === Http.Found && response.data) {
        const formTemplates = response.data.data;
        const formTemplatesArray: List[] = [];
        formTemplates.forEach(({ _key, name }) => {
          formTemplatesArray.push({ key: _key, name: name });
        });
        this.formTemplatesList = [
          ...this.formTemplatesList,
          ...formTemplatesArray
        ];
        this.formTemplatesList = this.formTemplatesList.sort(
          (template1, template2) => template1.name.localeCompare(template2.name)
        );
        this.lastRefFormTemplate = response.data.docref;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getDiagnosticsCodes() {
    if (this.diagnosisCodes.length > 0) {
      return;
    }
    const fetchDiagnosisCodes = await this.getListDataById(
      ID_LIST.DIAGNOSIS_CODE
    );
    this.diagnosisCodes = fetchDiagnosisCodes!.map(item => item.key);
  }

  async getCampus() {
    if (this.campusList.length > 0) {
      return;
    }
    try {
      const campusResponse = await this.campusService.getAllCampus();
      if (campusResponse.code) {
        this.campusList = (campusResponse.data as unknown) as {
          key: string;
          name: string;
        }[];
        console.log("campus", this.campusList);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(a =>
          listDataList.push({ key: a.title, name: a.title })
        );
        return listDataList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getTemplate() {
    try {
      const responseData = await this.orderService.getTemplate();

      if (responseData.code == Http.Found && responseData.data !== undefined) {
        this.fieldsOrder = responseData.data.fields;
        await this.getSchema();
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ORDER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getSchema() {
    try {
      const responseData = await this.orderService.getOrderTempSchema();

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.fieldsOrder.forEach(i => {
          if (i.type === FORMS_CONSTANTS.FIELD_TYPE.LIST) {
            if (i.visualElement === FORMS_CONSTANTS.FIELD.CHECKBOX) {
              i.schema.items =
                responseData.data?.allOf[0].properties[i.key].items;
            } else {
              i.schema.oneOf =
                responseData.data?.allOf[0].properties[i.key].oneOf;
            }
          }
        });
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ORDER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async preloadActions() {
    this.actions = [];
    this.actionsTypes[0].actions = [];
    this.actionsTypes[1].actions = [];
    this.actionsTypes[2].actions = [];
    this.actionsTypes[3].actions = [];
    this.actionsTypes[4].actions = [];
    this.actionsTypes[5].actions = [];
    this.actionsTypes[6].actions = [];
    this.actionsTypes[7].actions = [];
    this.actionsTypes[8].actions = [];

    try {
      const responseAction = await this.generalRulesService.getGeneralRuleById(
        this.ruleId
      );

      if (
        responseAction.code === Http.Found &&
        responseAction.data !== undefined
      ) {
        this.generalRule = responseAction.data;
        this.actions = responseAction.data.actions;
        for (const value of [...this.actions]) {
          switch (value.type) {
            case GENERAL_RULES_CONSTANTS.MEDICAL_ORDER:
              await this.processMedicalOrderToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.NOTIFICATION:
              this.processNotificationToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.TASK:
              this.processTaskToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.DOCUMENTS:
              this.processGenerateDocumentToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.FORM:
              this.processFormToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.SERVICE:
              this.processServiceToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.RPA:
              this.processRpaToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION:
              this.processChangeServiceStateToRender(value);
              break;
            case GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER:
              this.processChangeMedicalOrderToRender(value);
              break;
          }
        }
        this.editComparationStr = JSON.stringify(this.actions);
      } else {
        Snackbar.popInfo(responseAction.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + RULES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  processRpaToRender(value: ActionGeneralRules) {
    this.actionsTypes[6].actions.push(value);
    this.assingActions();
  }

  processServiceToRender(value: ActionGeneralRules) {
    this.actionsTypes[5].actions.push(value);
    this.assingActions();
  }

  processNotificationToRender(value: ActionGeneralRules) {
    this.actionsTypes[2].actions.push(value);
    this.assingActions();
  }

  processChangeServiceStateToRender(value: ActionGeneralRules) {
    this.actionsTypes[7].actions.push(value);
    this.assingActions();
  }

  processChangeMedicalOrderToRender(value: ActionGeneralRules) {
    this.actionsTypes[8].actions.push(value);
    this.assingActions();
  }

  async processMedicalOrderToRender(actionToPreload: ActionGeneralRules) {
    if (actionToPreload.medicalOrder && actionToPreload.medicalOrder.cups) {
      if (this.cupsStore.length === 0) {
        try {
          const responseCups: Response<CupsPriceLevelHeader[]> = await this.cupsPriceLevelService.getAllActiveCupsPriceLevel();
          if (
            responseCups.code === Http.Found &&
            responseCups.data !== undefined
          ) {
            this.cupsStore = responseCups.data;

            const cup = this.cupsStore.find(
              cup => cup.id === actionToPreload.medicalOrder!.cups.key
            )!;

            actionToPreload.medicalOrder!.cups = cup?.externalName;

            for (const key in cup?.clients) {
              this.priceLvlsList.keys.push(key);
              this.priceLvlsList.values.push(
                `${cup.clients[key].name} ${cup.clients[key].price}`
              );
            }

            if (
              actionToPreload.medicalOrder!.priceLevel !== undefined &&
              actionToPreload.medicalOrder!.priceLevel.key !== ""
            ) {
              actionToPreload.medicalOrder!.priceLevelKey = actionToPreload.medicalOrder!.priceLevel.key;
              actionToPreload.medicalOrder!.priceLevel =
                cup.clients[actionToPreload.medicalOrder!.priceLevel.key].name +
                " " +
                cup.clients[actionToPreload.medicalOrder!.priceLevel.key].price;
            } else {
              actionToPreload.medicalOrder!.priceLevel = "";
            }
          } else {
            Snackbar.popInfo(LACK_OF_OPTIONS);
          }
        } catch (error) {
          if ((error as AxiosError).response?.status == Http.Forbidden)
            Snackbar.popError(
              FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET
            );
          else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        }
      } else {
        const cup = this.cupsStore.find(
          cup => cup.id === actionToPreload.medicalOrder!.cups.key
        )!;

        actionToPreload.medicalOrder!.cups = cup?.externalName;
        for (const key in cup?.clients) {
          this.priceLvlsList.keys.push(key);
          this.priceLvlsList.values.push(
            `${cup.clients[key].name} ${cup.clients[key].price}`
          );
        }

        if (
          actionToPreload.medicalOrder!.priceLevel !== undefined &&
          actionToPreload.medicalOrder!.priceLevel.key !== ""
        ) {
          actionToPreload.medicalOrder!.priceLevel =
            cup.clients[actionToPreload.medicalOrder!.priceLevel.key].name +
            " " +
            cup.clients[actionToPreload.medicalOrder!.priceLevel.key].price;
        } else {
          actionToPreload.medicalOrder!.priceLevel = "";
        }
      }
      if (this.orderStates.length === 0) await this.getOrderStates();
      actionToPreload.medicalOrder!.state = this.orderStates?.find(
        state => state.id === actionToPreload.medicalOrder!.state
      )!.name as string;
    }

    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.MEDICAL_ORDER,
      medicalOrder: actionToPreload.medicalOrder,
      daysToApply: actionToPreload.daysToApply,
      stopConditions: actionToPreload.stopConditions
    };
    this.actionsTypes[0].actions.push(action);
    this.assingActions();
    await this.getCampus();
    await this.getDiagnosticsCodes();
    await this.loadServiceSemplate();
  }

  processTaskToRender(actionToPreload: ActionGeneralRules) {
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.TASK,
      task: actionToPreload.task,
      daysToApply: actionToPreload.daysToApply,
      stopConditions: actionToPreload.stopConditions
        ? actionToPreload.stopConditions
        : []
    };
    if (actionToPreload.task) {
      const formTemplate = actionToPreload.task.formTemplate as KeyValue;
      this.formTemplatesList = [formTemplate, ...this.formTemplatesList];
    }

    this.actionsTypes[1].actions.push(action);
    this.assingActions();
  }

  processGenerateDocumentToRender(actionToPreload: ActionGeneralRules) {
    const action = {
      type: GENERAL_RULES_CONSTANTS.DOCUMENTS,
      actionPlan: actionToPreload.actionPlan,
      daysToApply: 0
    };

    this.actionsTypes[3].actions.push(action);
    this.assingActions();
  }

  processFormToRender(value: ActionGeneralRules) {
    this.actionsTypes[4].actions.push(value);
    this.assingActions();
  }

  openStopConditionsModal(indexAction: number, actionType: string) {
    this.executeRulesNotidicationModal = false;
    this.fieldsForStopConditions = this.collection.fields.filter(
      field => field.showInStopConditios
    );
    this.indexInContainer = indexAction;
    this.actionTypeIndex = this.actionsTypes.findIndex(
      item => item.actionType == actionType
    );

    if (this.actionTypeIndex != -1) {
      const action: ActionGeneralRules = this.actionsTypes[this.actionTypeIndex]
        .actions[indexAction];
      this.stopConditions = action.stopConditions
        ? [...(action.stopConditions as StopCondition[])]
        : [];
      if (this.validateIfConditionsCanBeConfigured(indexAction, actionType))
        this.showStopConditionsModal = true;
      else Snackbar.popInfo(GENERAL_RULES_CONSTANTS.STOP_CONDITION_ALERT);
    }
  }

  onCloseModal() {
    this.showModalNotifications = false;
    this.showStopConditionsModal = false;
  }

  onSaveStopConditions(stopConditions: StopCondition[]) {
    if (stopConditions.length > 0) {
      stopConditions = stopConditions.map(condition => {
        delete condition.operatorList;
        return condition;
      });
    } else {
      stopConditions = [];
    }
    this.showStopConditionsModal = false;
    this.actionsTypes[this.actionTypeIndex].actions[
      this.indexInContainer
    ].stopConditions = stopConditions;
    this.sendActions();
  }

  validateIfConditionsCanBeConfigured(indexAction: number, actionType: string) {
    const typeAction = this.actionsTypes.find(
      action => action.actionType == actionType
    );
    if (typeAction) {
      const action = typeAction.actions[indexAction];
      if (
        action.daysToApply > 0 ||
        (actionType == GENERAL_RULES_CONSTANTS.NOTIFICATION &&
          action.actionNotification?.notification.frequency &&
          action.actionNotification.notification.frequency > 0) ||
        this.generalRule.conditions.find(
          condition => condition.key == FILTERS_NAMES_CONST.TIME_ELAPSED.key
        )
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  saveFormAction(formConfiguration: FormConfiguration) {
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.FORM,
      form: formConfiguration,
      daysToApply: 0,
      stopConditions: []
    };

    if (this.editForm) {
      Vue.set(this.actionsTypes[4].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.editForm = false;
      this.assingActions();
    } else {
      this.actionsTypes[4].actions.push(action);
      this.actions.push(action);
    }
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.showModalForms = false;
  }

  cancelFormAction() {
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.editForm = false;
    this.showModalForms = false;
  }

  assingActions() {
    this.actions = [
      ...this.actionsTypes[0].actions,
      ...this.actionsTypes[1].actions,
      ...this.actionsTypes[2].actions,
      ...this.actionsTypes[3].actions,
      ...this.actionsTypes[4].actions,
      ...this.actionsTypes[5].actions,
      ...this.actionsTypes[6].actions,
      ...this.actionsTypes[7].actions,
      ...this.actionsTypes[8].actions
    ];
  }

  searchActionType(keyWord: string) {
    this.listenConditions();
    if (!keyWord) {
      return;
    }

    this.filterActions = this.filterActions.filter(item =>
      item.toLowerCase().startsWith(keyWord.toLowerCase())
    );
  }

  getServiceToAssign(service: Service, daysToApply: number) {
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.SERVICE,
      assignService: service,
      daysToApply: daysToApply
    };
    if (this.editService) {
      Vue.set(this.actionsTypes[5].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.editService = false;
      this.assingActions();
    } else {
      this.actionsTypes[5].actions.push(action);
      this.actions.push(action);
    }
    this.actionToEdit = lodash.cloneDeep(DEFAULT_ACTION);
    this.editService = false;
    this.showAssignServiceModal = false;
  }

  handleCloseAssignService() {
    this.showAssignServiceModal = false;
    this.editService = false;
  }

  @Watch("conditions", { deep: true })
  listenConditions() {
    this.checkExeNotificationsConditions();
    if (this.collection.key == FILTERS_NAMES_CONST.FORM.KEY) {
      const formTemplate = this.conditions.find(
        item => item.key == FILTERS_NAMES_CONST.FORM.FIELDS.FORMTEMPLATE.name
      );

      this.formTemplateSelected =
        formTemplate && formTemplate.value
          ? formTemplate.value.map((item: any) => item.key)
          : [];
    }
    if (this.collection.name !== GENERAL_RULES_CONSTANTS.SERVICIO) {
      this.filterActions = [...GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN];
      return;
    }

    const state = this.conditions.find(
      item =>
        item.key === FILTERS_NAMES_CONST.SERVICE.FIELDS.STATUS.name &&
        item.value
    );

    if (!state) {
      this.filterActions = [...GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN].slice(
        0,
        5
      );
      return;
    }

    this.filterActions = [...GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN];
  }

  openExecutionNotificationRules(index: number, type: string) {
    this.fieldsForStopConditions = this.executeConditionsNotificationList;
    this.indexInContainer = index;
    this.actionTypeIndex = this.actionsTypes.findIndex(
      item => item.actionType == type
    );

    if (this.actionTypeIndex != -1) {
      const action: ActionGeneralRules = this.actionsTypes[this.actionTypeIndex]
        .actions[index];
      this.stopConditions = action.exeRulesNotification
        ? [...(action.exeRulesNotification as StopCondition[])]
        : [];
      this.showStopConditionsModal = true;
      this.executeRulesNotidicationModal = true;
    }
  }

  saveNotificationEXERule(exeRule: StopCondition[]) {
    if (exeRule.length > 0) {
      exeRule = exeRule.map(condition => {
        delete condition.operatorList;
        return condition;
      });
    } else {
      exeRule = [];
    }
    this.showStopConditionsModal = false;
    this.executeRulesNotidicationModal = false;
    this.actionsTypes[this.actionTypeIndex].actions[
      this.indexInContainer
    ].exeRulesNotification = [...exeRule];
    this.sendActions();
  }
  checkExeNotificationsConditions() {
    this.executeConditionsNotificationList = [];
    NOTIFICATION_EXE_RULES_FIELDS.forEach(field => {
      if (field.codependency && this.conditions && this.conditions.length > 0) {
        const condition = this.conditions.find(
          condition => condition.key == field.codependency.fieldName
        );
        if (condition) {
          const valid = (condition.value as List[]).find(
            val => val.name == field.codependency.fieldValue
          );
          if (valid) {
            this.executeConditionsNotificationList.push(field);
          }
        }
      } else {
        this.executeConditionsNotificationList.push(field);
      }
    });
  }

  closeChangeServiceStateModal() {
    this.showChangeServiceStateModal = false;
  }

  saveActionServiceStateModal(event: ChangeStateServiceModel) {
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION,
      daysToApply: 0,
      changeStateService: {
        serviceTemplate: event.serviceTemplate,
        state: event.state
      }
    };
    if (this.edit) {
      Vue.set(this.actionsTypes[7].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.edit = false;
      this.assingActions();
    } else {
      this.actionsTypes[7].actions.push(action);
      this.actions.push(action);
    }

    this.showChangeServiceStateModal = false;
  }

  closeActionChangeMedicalOrderModal() {
    this.showChangeMedicalOrderModal = false;
  }

  saveActionChangeMedicalOrderModal(event: ChangeMedicalOrderModel) {
    const action: ActionGeneralRules = {
      type: GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER,
      daysToApply: 0,
      changeMedicalOrder: event
    };
    if (this.edit) {
      Vue.set(this.actionsTypes[8].actions, this.indexInContainer, action);
      this.indexInContainer = -1;
      this.actionType = "";
      this.edit = false;
      this.assingActions();
    } else {
      this.actionsTypes[8].actions.push(action);
      this.actions.push(action);
    }
    this.closeActionChangeMedicalOrderModal();
  }

  async getOrderStates() {
    try {
      const response = await this.listService.getListOptionsByName(
        LIST_CONSTANTS.ORDER_STATES_LIST_NAME
      );

      if (response.code === Http.Found && response.data) {
        this.orderStates = response.data.map(item => {
          return { id: item.id as string, name: item.title as string };
        });
        store.commit("setOrderStates", this.orderStates);
        return;
      }
      Snackbar.popInfo(response.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  renderServiceNameOfChangeServiceStateAction(
    changeStateService: ChangeStateServiceModel
  ) {
    if (changeStateService.serviceTemplate.length > 0) {
      return changeStateService.serviceTemplate[0].name;
    }
    return RELATED_SERVICE;
  }
}
